import { KeyboardArrowDown } from "@mui/icons-material"
import { MenuItem, Select, Box, FormControl } from "@mui/material"

const OneSelect = ({
    name,
    options = [],
    defaultValue,
    disabled,
    label = "descricao",
    valor = "id",
    separado = false,
    newSx,
    centralizarOpcoes = true,
    ...rest
}) => {
    const renderValue = (selectedValue, options) => {
        const selectedOption = options.find((option) => option[valor] === selectedValue)
        if (selectedOption) {
            return selectedOption[label]
        } else {
            const opt = options[0]
            return opt[label]
        }
    }
    return (
        <Box sx={{
            width: '100%'
        }}>
            <FormControl fullWidth>
                <Select
                    name={name}
                    disabled={disabled}
                    sx={{
                        // border: '1px solid yellow',
                        backgroundColor: (disabled ? "#c9c7c7" : "#fff"),
                        boxShadow: 'none',
                        '.MuiOutlinedInput-notchedOutline': { border: 'none' },
                        fontWeight: 400,
                        fontSize: '14px',
                        color: 'black',
                        width: '100%',
                        height: '30px',
                        padding: '0 3px',
                        '& .MuiSelect-icon': {
                            color: '#929292'
                        },
                        ...newSx
                    }}
                    inputProps={{
                        sx: { padding: '0 5px', ...newSx }
                    }}
                    IconComponent={KeyboardArrowDown}
                    MenuProps={{
                        autoFocus: false,
                        PaperProps: {
                            sx: {
                                border: '1px solid #8a05be',
                                maxWidth: '500px',
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: centralizarOpcoes ? 'center' : 'flex-start'
                            }
                        },
                        sx: { '& .Mui-selected': { backgroundColor: '#9d56b93f' } }
                    }}
                    renderValue={(selectedValue) => renderValue(selectedValue, options)}
                    defaultValue={defaultValue !== undefined ? defaultValue : ''}
                    {...rest}
                >
                    { options.map((option, i) => (
                        <MenuItem key={`menu_select_${i}`} value={option[valor]}>
                            {!separado
                                ? (<span>{option[label]}</span>)
                                : (<><span style={{ width: "45px" }}>{option[valor]}</span><span> - {option[label]}</span></>)
                            }
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    )
}

export default OneSelect
